<template>
  <div class="support-wrapper">
    <v-container class="custom-container">
      <v-row no-gutters class="currency-wrapper" dense>
        <v-col cols="12" lg="4" class="currency-column-left">
          <CurrencyGroup></CurrencyGroup>
        </v-col>
        <v-col cols="12" lg="8" class="currency-column-right">
          <PairsSymbols></PairsSymbols>
        </v-col>
      </v-row>
      <v-tabs class="support-tabs currency-support-tabs" vertical
        :background-color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
        <v-row class="flex-column">
          <v-col cols="12" md="12">
            <div class="header">
              <span>Group Name</span>
              <span>Action</span>
            </div>
            <v-tab v-for="group in groups" :key="group?.id"
              class="text-left justify-start support-tab content-support-tab" @click="handleTabClick(group)">
              <div class="content">
                <p>{{ group?.title }}</p>
                <div class="trade-dropdown" v-if="$canRoute('currency') === 1">
                  <v-menu rounded="0" class="trade-dropdown-menu" transition="slide-x-transition" bottom left>
                    <template v-slot:activator="{ attrs, on }">
                      <v-btn small tile elevation="0" class="ma-0 text-capitalize btn-account" v-bind="attrs" v-on="on"
                        icon>
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-card class="dropdown-menu-card" tile flat>
                      <v-list flat elevation="0" :class="$vuetify.theme.dark
                        ? '$blue-darken-1'
                        : 'white-lighten-1'
                        ">
                        <v-list-item-group>
                          <v-list-item :ripple="false" link>
                            <v-list-item-content>
                              <v-dialog transition="scale-transition" origin="center center" max-width="324"
                                v-model="dialog[group?.id]">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn tile small v-bind="attrs" v-on="on" elevation="0"
                                    class="text-capitalize btn-account" color="teal-lighten-1"
                                    @click="handleEditGroupSelectEdit(group)">Edit</v-btn>
                                </template>

                                <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark
                                  ? 'blue-darken-1'
                                  : 'white-lighten-5'
                                  ">
                                  <v-card-title class="pb-3 text-left justify-start pl-3">
                                    Update {{ group?.title }}
                                  </v-card-title>
                                  <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
                                    At First Select The Group, then write new
                                    currency pair
                                  </v-card-subtitle>
                                  <v-card class="deposit-form px-3 py-4" :class="$vuetify.theme.dark
                                    ? 'blue-darken-1'
                                    : 'white-lighten-5'
                                    ">
                                    <v-row>
                                      <v-col cols="12">
                                        <fieldset>
                                          <legend>Group Name</legend>
                                          <v-text-field label="Write Pair Name Here" single-line solo hide-details
                                            class="custom-select" v-model="groupName"></v-text-field>
                                          <span v-if="
                                            isGroupEditClicked && !groupName
                                          " style="
                                              color: red;
                                              font-size: 12px;
                                              margin-top: 1px;
                                            ">Group Name field is required</span>
                                        </fieldset>
                                      </v-col>
                                    </v-row>
                                  </v-card>
                                  <v-card-actions class="mt-10">
                                    <v-row dense>
                                      <v-col cols="6">
                                        <v-btn tile block @click="handleUpdateGroup" elevation="0"
                                          class="text-capitalize btn-account" color="teal-lighten-1">Update</v-btn>
                                      </v-col>
                                      <v-col cols="6">
                                        <v-btn tile block outlined @click="handleCloseEditGroup(group)" elevation="0"
                                          class="text-capitalize btn-account">Cancel</v-btn>
                                      </v-col>
                                    </v-row>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>

                              <v-dialog v-model="deleteDialog[group?.id]" max-width="400" class="rounded-0">
                                <template v-slot:activator="{ on }">
                                  <v-btn tile small v-bind="attrs" v-on="on" elevation="0"
                                    class="text-capitalize btn-account" color="teal-lighten-1" @click="
                                      this.$set(
                                        this.deleteDialog,
                                        group?.id,
                                        true
                                      )
                                      ">
                                    Delete
                                  </v-btn>
                                </template>
                                <v-card rounded="0" width="400" class="auth-modal-card" :color="$vuetify.theme.dark ? '#111A26' : '#ffffff'
                                  ">
                                  <v-card-title class="px-0 pt-0">
                                    Delete {{ group?.title }}?
                                  </v-card-title>
                                  <v-card-text class="px-0">Do You want to delete?</v-card-text>
                                  <v-card-actions class="px-0 pb-0">
                                    <v-btn class="elevation-0" :color="$vuetify.theme.dark
                                      ? '#FF567F'
                                      : '#FF567F'
                                      " @click="handleDeleteGroup(group)">
                                      Delete
                                    </v-btn>
                                    <v-btn class="elevation-0" :color="$vuetify.theme.dark
                                      ? '#111A26'
                                      : '#ffffff'
                                      " outlined @click="handleDeleteGroupCancel(group)">
                                      Cancel
                                    </v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-card>
                  </v-menu>
                </div>
              </div>
            </v-tab>
          </v-col>
        </v-row>

        <v-tab-item v-for="(tabItem, index) in tabItems" :key="index" class="bg-transparent">
          <v-sheet class="transactionTable currencyTable"
            :class="$vuetify.theme.dark ? 'blue-darken-5 ' : 'white-lighten-1'">
            <v-row dense>
              <v-col cols="12">
                <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search symbols ..." single-line solo
                  hide-details class="custom-v-input"></v-text-field>
              </v-col>
            </v-row>
            <v-data-table :headers="headers" :items="currencies" :search="search">
              <template v-slot:item.sl="{ item, index }">
                {{ index + 1 }}
              </template>
              <template v-slot:item.action="{ item }" >
                <div class="trade-dropdown" v-if="$canRoute('currency') === 1">
                  <v-menu rounded="0" class="trade-dropdown-menu" transition="slide-x-transition" bottom left>
                    <template v-slot:activator="{ attrs, on }">
                      <v-btn small tile elevation="0" class="ma-0 text-capitalize btn-account" v-bind="attrs" v-on="on"
                        icon>
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-card class="dropdown-menu-card" tile flat>
                      <v-list flat elevation="0" :class="$vuetify.theme.dark
                        ? 'blue-darken-1'
                        : 'white-lighten-1'
                        ">
                        <v-list-item-group>
                          <v-list-item :ripple="false" link>
                            <v-list-item-content>
                              <v-dialog transition="scale-transition" origin="center center" max-width="324"
                                v-model="currencyDialog[item?.id]">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn tile small v-bind="attrs" v-on="on" elevation="0"
                                    class="text-capitalize btn-account" color="teal-lighten-1" @click="
                                      this.$set(
                                        this.currencyDialog,
                                        item?.id,
                                        true
                                      )
                                      ">Edit</v-btn>
                                </template>

                                <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark
                                  ? 'blue-darken-1'
                                  : 'white-lighten-5'
                                  ">
                                  <v-card-title class="pb-3 text-left justify-start pl-3">
                                    Update
                                  </v-card-title>
                                  <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
                                    At First Select The Group, then write new
                                    currency pair
                                  </v-card-subtitle>
                                  <v-card class="deposit-form px-3 py-4" :class="$vuetify.theme.dark
                                    ? 'blue-darken-1'
                                    : 'white-lighten-5'
                                    ">
                                    <v-row>
                                      <v-col cols="12">
                                        <fieldset>
                                          <legend>Select Group</legend>
                                          <v-select solo :items="groupOptions" append-icon="mdi-chevron-down" :label="$route && $route.query.group
                                            ? $route.query.group
                                            : 'Select Group'
                                            " class="custom-select" hide-details v-model="selectedGroup"
                                            item-text="title" item-value="id"></v-select>
                                        </fieldset>
                                      </v-col>
                                      <v-col cols="12">
                                        <fieldset>
                                          <legend>Pair Name</legend>
                                          <v-text-field :label="item.symbol" single-line solo hide-details
                                            class="custom-select" v-model="pairName"></v-text-field>
                                        </fieldset>
                                      </v-col>
                                    </v-row>
                                  </v-card>
                                  <v-card-actions class="mt-10">
                                    <v-row dense>
                                      <v-col cols="6">
                                        <v-btn tile block @click="handleUpdateCurrency(item)" elevation="0"
                                          class="text-capitalize btn-account" color="teal-lighten-1">Update</v-btn>
                                      </v-col>
                                      <v-col cols="6">
                                        <v-btn tile block outlined @click="handleCloseEditCurrency(item)" elevation="0"
                                          class="text-capitalize btn-account">Cancel</v-btn>
                                      </v-col>
                                    </v-row>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                              <v-dialog v-model="deleteCurrencyDialog[item?.id]" max-width="400" class="rounded-0">
                                <template v-slot:activator="{ on }">
                                  <v-btn tile small v-bind="attrs" v-on="on" elevation="0"
                                    class="text-capitalize btn-account" color="teal-lighten-1" @click="
                                      this.$set(
                                        this.deleteCurrencyDialog,
                                        item?.id,
                                        true
                                      )
                                      ">
                                    Delete
                                  </v-btn>
                                </template>
                                <v-card rounded="0" width="400" class="auth-modal-card" :color="$vuetify.theme.dark ? '#111A26' : '#ffffff'
                                  ">
                                  <v-card-title class="px-0 pt-0">
                                    Delete {{ item?.symbol }}?
                                  </v-card-title>
                                  <v-card-text class="px-0">Do You want to delete?</v-card-text>
                                  <v-card-actions class="px-0 pb-0">
                                    <v-btn class="elevation-0" :color="$vuetify.theme.dark
                                      ? '#FF567F'
                                      : '#FF567F'
                                      " @click="handleDeleteCurrency(item)">
                                      Delete
                                    </v-btn>
                                    <v-btn class="elevation-0" :color="$vuetify.theme.dark
                                      ? '#111A26'
                                      : '#ffffff'
                                      " outlined @click="handleCloseDeleteCurrency(item)">
                                      Cancel
                                    </v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-card>
                  </v-menu>
                </div>
                <div class="text-end" v-else>No Action</div>
              </template>
            </v-data-table>
          </v-sheet>
        </v-tab-item>
      </v-tabs>
    </v-container>
  </div>
</template>

<script>
import CurrencyGroup from "@/components/Partners/CurrencyGroup.vue";
import PairsSymbols from "@/components/Partners/PairsSymbols.vue";
import { mapActions, mapState } from "vuex";
import { CURRENCY__ACTIONS } from "@/store/action-types";
import router from "@/router";
import toast from "@/services/Notification";

export default {
  data() {
    return {
      search: null,
      dialog: {},
      deleteDialog: {},
      currencyDialog: {},
      deleteCurrencyDialog: {},
      selectedEditGroup: null,
      groupName: null,
      pairName: null,
      selectedGroup: null,
      isEditBtnClicked: false,
      isGroupEditClicked: false,
      headers: [
        { text: "SL", align: "start", value: "sl" },
        { text: "Currency Symbols", value: "symbol" },
        { text: "Action", value: "action" },
      ],
    };
  },

  components: {
    CurrencyGroup,
    PairsSymbols,
  },

  computed: {
    ...mapState("currencies", ["currencies", "groups"]),
    ...mapState("admins", ["loggedAdmin"]),

    groupOptions() {
      return this.groups.map((group) => ({
        id: group?.id,
        title: group?.title,
      }));
    },

    tabItems() {
      return this.groups?.map((group) => ({
        currencies: this.currencies?.filter(
          (currency) => currency?.groupId === group?.id
        ),
      }));
    },
  },

  methods: {
    ...mapActions("currencies", [
      CURRENCY__ACTIONS.ACTIVECURRENCIES,
      CURRENCY__ACTIONS.ACTIVECURRENCYGROUPS,
      CURRENCY__ACTIONS.DELETEGROUP,
      CURRENCY__ACTIONS.DELETECURRENCY,
      CURRENCY__ACTIONS.UPDATECURRENCYGROUP,
      CURRENCY__ACTIONS.UPDATECURRENCYSYMBOL,
    ]),

    handleEditGroupSelectEdit(group) {
      this.selectedEditGroup = group.id;
      this.$set(this.dialog, group?.id, false);
    },

    handleTabClick(group) {
      if (this.$route.query.group !== group?.title) {
        this.$router.push({
          path: this.$route.path,
          query: { group: group?.title }
        }).catch(err => {
          console.log(err)
        });
      }

      const parameter = {
        id: group?.id
      };
      this[CURRENCY__ACTIONS.ACTIVECURRENCIES](parameter);
    },

    handleDeleteGroup(group) {
      const parameter = {
        id: group?.id,
      };
      this[CURRENCY__ACTIONS.DELETEGROUP](parameter);
      this.$set(this.deleteDialog, group?.id, false);
    },

    handleUpdateGroup() {
      this.isGroupEditClicked = true;
      const parameter = {
        id: this.selectedEditGroup,
        title: this.groupName.toUpperCase(),
      };
      this[CURRENCY__ACTIONS.UPDATECURRENCYGROUP](parameter);
      this.$set(this.dialog, this.selectedEditGroup, false);
      this.selectedEditGroup = null;
      this.groupName = null;
    },

    handleUpdateCurrency(item) {
      this.isEditBtnClicked = true;
      const parameter = {
        id: item.id,
        partner_currency_group_id: this.selectedGroup
          ? this.selectedGroup
          : item.partner_currency_group_id,
        symbol: this.pairName ? this.pairName.toUpperCase() : item.symbol,
      };
      this[CURRENCY__ACTIONS.UPDATECURRENCYSYMBOL](parameter);
      this.$set(this.currencyDialog, item?.id, false);
      this.selectedGroup = null;
      this.pairName = null;
    },

    handleDeleteCurrency(item) {
      const parameter = {
        id: item?.id,
      };
      this[CURRENCY__ACTIONS.DELETECURRENCY](parameter);
      this.$set(this.deleteCurrencyDialog, item?.id, false);
    },

    handleCloseDeleteCurrency(item) {
      this.$set(this.deleteCurrencyDialog, item?.id, false);
    },

    handleDeleteGroupCancel(item) {
      this.$set(this.deleteDialog, item?.id, false);
    },

    handleCloseEditCurrency(item) {
      this.$set(this.currencyDialog, item?.id, false);
      this.selectedGroup = null;
      this.pairName = null;
    },

    handleCloseEditGroup(item) {
      this.$set(this.dialog, item?.id, false);
      this.selectedEditGroup = null;
      this.groupName = null;
    },
  },

  created() {
    this[CURRENCY__ACTIONS.ACTIVECURRENCIES]();
    this[CURRENCY__ACTIONS.ACTIVECURRENCYGROUPS]();
  },
};
</script>

<style>
.text-end{
  text-align: center !important;
}
</style>